import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { SearchConfig } from "@/components/dynamic-form";
import { SearchBarType } from "@/components/dynamic-form/constants";
import dayjs from "dayjs";

export function getSearchConfig(): SearchConfig[] {
  const t = getTranslateNsT("center");
  return [
    {
      type: SearchBarType.DatePicker,
      field: "time",
      label: t("consumption_time_selector"),
      isTrendsChangeDate: true,
      limitMonthNum: 12,
      props: {
        allowClear: false,
        picker: "month",
        defaultValue: [
          dayjs(
            new Date(new Date().getFullYear(), new Date().getMonth() - 3, 1)
          ),
          dayjs(
            new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1)
          ),
        ],
      },
    },
    {
      type: SearchBarType.Select,
      label: t("user_operate_record_user_name"),
      field: "userId",
      props: {
        placeholder: t("user_consume_pick_platform_all"),
        dropdownMatchSelectWidth: false,
        options: [
          { label: t("user_consume_pick_project_all"), value: 0 },
          { label: t("header_user_tool_consume_list"), value: 1 },
          { label: t("user_export_list_render_list"), value: 2 },
          { label: t("user_export_render_task_type_13"), value: 13 },
          { label: t("user_export_render_task_type_14"), value: 14 },
          { label: t("user_export_render_task_type_15"), value: 15 },
          { label: t("user_export_render_task_type_16"), value: 16 },
        ],
      },
    },
    {
      type: SearchBarType.Input,
      field: "company",
      label: t("consumption_table_header_company"),
      props: {
        placeholder: t("user_binfo_perfect_item_company_placeholder"),
      },
    },
    {
      type: SearchBarType.Select,
      label: t("consumption_label_fee_type"),
      field: "feeType",
      props: {
        placeholder: t("user_consume_pick_platform_all"),
        dropdownMatchSelectWidth: false,
        options: [
          {
            label: t("consumption_fee_type_0"),
            value: 0,
          },
          {
            label: t("consumption_fee_type_1"),
            value: 1,
          },
          {
            label: t("consumption_fee_type_3"),
            value: 3,
          },
        ],
      },
    },
    {
      type: SearchBarType.Select,
      label: getTranslateNsT("center")("consumption_label_node_type"),
      field: "nodeType",
      props: {
        placeholder: t("user_consume_pick_platform_all"),
        dropdownMatchSelectWidth: false,
        options: [
          {
            label: "CPU",
            value: 0,
          },
          {
            label: "GPU",
            value: 1,
          },
        ],
      },
    },
  ];
}
